import {
  FETCH_PARKING_HISTORY,
  FETCH_PARKING_HISTORY_SUCCESS,
  FETCH_PARKING_HISTORY_ERROR,
} from './types';

const initialState = {
  permits: [],
  isLoading: false,
  error: null,
};

const parkingHistoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Fetch parking history
    case FETCH_PARKING_HISTORY:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_PARKING_HISTORY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        permits: payload,
      };
    case FETCH_PARKING_HISTORY_ERROR:
      return {
        ...state,
        isLoading: false,
        error: 'Failed to fetch parking history',
      };

    default:
      return state;
  }
};

export default parkingHistoryReducer;
